// extracted by mini-css-extract-plugin
export default {"invalidSearchInput":"UsersAutoComplete_invalidSearchInput__9nDoX"};